module.exports = __webpack_public_path__ + "static/img/edit.3a333364.png";